import { Dispatch } from 'react'
import { AppState } from '../../store'
import { AuthAction } from './reducers'
import * as api from '../services/api'
import * as tokenService from '../../services/token'
import { ApiResponse } from '../../../modules/types'

import {
  LOGIN_REQUEST,
  LOGIN_RECEIVED,
  LOGIN_ERROR,
  LOGIN_INVALID,
  LOGOUT,
  REMOVE_USER_DATA
} from './reducers'

const PAPERTRAIL_ID = '6d60618e-a36f-44ae-b008-42703ff5952b'

export function login(username: string, password: string, keepUserLoggedIn: boolean) {
  return async function (state: AppState, dispatch: Dispatch<AuthAction>) {
    try {
      dispatch({
        type: LOGIN_REQUEST
      })

      const result = await api.postLogin(username, password)
      tokenService.saveToken(result.access_token, keepUserLoggedIn)

      const user = await api.getCurrentUser()
      const mappedUser = getMappedUser(user)
      const partners = await api.getPartners()


      if (partners.data.length) {
        const partnerIds = partners.data.map((partner: ApiResponse) => partner.id)
        const isPapertrailEmployee = partnerIds.includes(PAPERTRAIL_ID)
        
        dispatch({
          type: LOGIN_RECEIVED,
          user: mappedUser,
          partners: partners.data,
          isPapertrailEmployee
        })
      } else {
        tokenService.clearToken()
        dispatch({
          type: LOGIN_INVALID
        })
      }
    } catch {
      dispatch({
        type: LOGIN_ERROR
      })
    }
  }
}

export function logout() {
  return async function (state: AppState, dispatch: Dispatch<AuthAction>) {
    await api.logout()
    tokenService.clearToken()

    dispatch({
      type: LOGOUT
    })
  }
}

export function refreshFromToken() {
  return async function (state: AppState, dispatch: Dispatch<AuthAction>) {
    try {
      dispatch({
        type: LOGIN_REQUEST
      })

      const user = await api.getCurrentUser()
      const mappedUser = getMappedUser(user)
      const partners = await api.getPartners()

      if (partners.data.length) {
        const partnerIds = partners.data.map((partner: ApiResponse) => partner.id)
        const isPapertrailEmployee = partnerIds.includes(PAPERTRAIL_ID)

        dispatch({
          type: LOGIN_RECEIVED,
          user: mappedUser,
          partners: partners.data,
          isPapertrailEmployee
        })
      }
    } catch (error) {
      tokenService.clearToken()
      dispatch({
        type: LOGIN_ERROR
      })
    }
  }
}

export function removeUserData() {
  return async function (state: AppState, dispatch: Dispatch<AuthAction>) {
    dispatch({
      type: REMOVE_USER_DATA
    })
  }
}

function getMappedUser(user: ApiResponse) {
  return {
    id: user.data.id,
    firstName: user.data.first_name,
    lastName: user.data.last_name,
    avatarUrl: user.data.avatar,
    avatarColour: user.data.avatar_colour,
    email: user.data.email,
    dateFormat: user.data.date_format,
    timeFormat: user.data.time_format,
    timezone: user.data.timezone,
    countryCode: user.data.country_code,
    intercomUserHash: user.data.intercom_user_hash
  }
}
